

import {  
  loadChangeLogDataInProgress,
  loadChangeLogDataSuccess,
  loadChangeLogDataFailure,
  loadChangeLogTypeListSuccess,
  loadChangeLogSubTypeListSuccess,
  changeLogOperationCompleted
} from "../state/changelog/actions";
import { oktaAuth } from '../auth/okta';
import dayjs from 'dayjs';
import swal from 'sweetalert';
import { errorSweetAlert } from "../components/SweetAlertMessages";
const serverBasePath=process.env.REACT_APP_SERVER_API_URL;
let abortController = null;

export const loadChangeLogs = (searchText,searchBy,logType='',changeSubLogType='',fromDate='',toDate='',page=0,pageSize=10) => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token'); 
    if (abortController) {
        abortController.abort();
    }
    abortController = new AbortController();
    const signal = abortController.signal;
    try {
        let formatedFromDate = fromDate ? dayjs(fromDate).format('YYYY-MM-DD') : '';
        let formatedToDate = toDate ? dayjs(toDate).format('YYYY-MM-DD') : '';
        dispatch(loadChangeLogDataInProgress());
        const response = await fetch(serverBasePath+"/changelog/getChangelogData?searchText="+searchText+"&searchBy="+searchBy+"&logType="+logType+"&subLogType="+changeSubLogType+"&fromDate="+formatedFromDate+"&toDate="+formatedToDate+"&page="+page+"&pageSize="+pageSize,
        {   
            signal,
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        });
        const data = await response.json();
        dispatch(changeLogOperationCompleted());
        if(response.status !== 200){
            swal("Error", data.error.message, "error");
            return;
        }
        dispatch(loadChangeLogDataSuccess(data));    
    } catch (e) {
        dispatch(loadChangeLogDataFailure());    
        if (e.name === "AbortError") {
           //errorSweetAlert({message:'The operation was aborted.'}); 
        }
    }
};

export const loadChangeLogType = () => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    try {
      const response = await fetch(serverBasePath+"/changelog/getChangeLogTypeList",
        {
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        });
        const data = await response.json();
         dispatch(changeLogOperationCompleted());
        if(response.status !== 200){
            swal("Error", data.error.message, "error");
            return;
        }
        dispatch(loadChangeLogTypeListSuccess(data));     
    } catch (e) {   
        dispatch(loadChangeLogDataFailure());   
        errorSweetAlert(e);  
    }
};

export const loadChangeLogSubType = (logType) => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    try {
      const response = await fetch(serverBasePath+"/changelog/getChangeLogSubType/"+logType,
        {
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        });
        const data = await response.json();
         dispatch(changeLogOperationCompleted());
        if(response.status !== 200){
            swal("Error", data.error.message, "error");
            return;
        }
        dispatch(loadChangeLogSubTypeListSuccess(data));     
    } catch (e) {   
        dispatch(loadChangeLogDataFailure());   
        errorSweetAlert(e); 
    }
};
